import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8a96de4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Capital" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caption" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "资本认可"),
  /*#__PURE__*/_createElementVNode("span", { class: "caption-en" }, "CAPITAL RECOGNITION")
], -1))
const _hoisted_3 = { class: "capital-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "caption-content" }, "2018年7月，完成C轮融资，由海峡资本领投，SIG等老股东跟投，融资金额过亿元。在此之前，互连众信还曾获得58同城姚劲波、唯猎资本、弘道资本、险峰长青、源码资本、华融天泽、SIG、玖创资本等顶级投资公司及投资者的青睐。", -1))
const _hoisted_5 = ["src"]

import { ref, inject, watch } from 'vue';

export default {
  setup(__props) {

const isShow = inject('isShow');
const start = ref(false)

watch(() => isShow.isShowCapital, () => {
  start.value = true
})

return (_ctx, _cache) => {
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_el_row, {
        ref: "caption",
        class: "capital-img",
        justify: "space-between",
        gutter: 80
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (item) => {
            return _withDirectives(_createVNode(_component_el_col, {
              span: 6,
              key: item,
              class: "a-z_in"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: require('@/assets/images/home/capital/'+item+'.png')
                }, null, 8, _hoisted_5)
              ]),
              _: 2
            }, 1024), [
              [_vShow, start.value]
            ])
          }), 64))
        ]),
        _: 1
      }, 512)
    ])
  ]))
}
}

}